import React from "react";
import styles from './FlightInfoLine.module.scss'
import {IAirport} from 'data/interfaces/products';
import LocationTime from './components/locationTime/LocationTime';
import PlaneIcon from './components/planeIcon';
import LineImg from './components/lineImg';
import LocationAirport from './components/locationAirport';
import TransitTime from './components/transitTime';

export interface IFlightInfoLine {
  timeOfTakeOff: number;
  timeOfLanding: number;
  originAirport: IAirport;
  destinationAirport: IAirport;
  flip?: boolean;
}

const FlightInfoLine = (props: IFlightInfoLine) => (
  <div
    className={styles.flightInfoLine}
  >
    <LocationTime
      {...props}
      timeOfTakeOff={props.timeOfTakeOff}
      timeOfLanding={props.timeOfLanding}
    />
    <LocationAirport
      {...props}
      originAirport={props.originAirport}
      destinationAirport={props.destinationAirport}
    />
    <TransitTime  {...props}/>
    <LineImg/>
    <PlaneIcon {...props}/>
    <LocationTime
      {...props}
      timeOfTakeOff={props.timeOfLanding}
      timeOfLanding={props.timeOfTakeOff}
      className={styles.leftLocationTime}
    />
    <LocationAirport
      {...props}
      originAirport={props.destinationAirport}
      destinationAirport={props.originAirport}
      className={styles.leftLocationTime}
    />
  </div>
);

FlightInfoLine.defaultProps = {};

export default FlightInfoLine;
